<button class="btn btn-outline" (click)="onClickButton($event)" [disabled]="disabled" [type]="type">
  <ng-content></ng-content>
</button>